import { QueryClient } from '@tanstack/react-query';
import { getSchools } from '@api/schools';
import { DESKTOP_PER_PAGE_OPTIONS } from '@constants';
import { STATE_PUBLIC_COLLEGE_FILTER, STATE_SPOTLIGHT_SCHOOL_SORT } from '@constants/stateSpotlight';
import { INITIAL_SCHOOL_SORT } from '@store/SchoolSearchFiltersStore';
import useStateSpotlightStore from '@store/StateSpotlightStore';

export const schoolListLoader = (queryClient: QueryClient) => () => {
  const { isLoaded, spotlight, appliedDefaults, carriedFilters } = useStateSpotlightStore.getState();

  if (!isLoaded || carriedFilters.schools) return null;

  const isApplyingDefaults = !!spotlight && !appliedDefaults.schools;
  const filters = {
    limit: DESKTOP_PER_PAGE_OPTIONS[0],
    ...(isApplyingDefaults && { [STATE_PUBLIC_COLLEGE_FILTER]: [spotlight.stateCode] }),
  };
  const sortByValues = isApplyingDefaults ? STATE_SPOTLIGHT_SCHOOL_SORT : INITIAL_SCHOOL_SORT;

  void queryClient.prefetchQuery({
    queryKey: ['schools', filters, false, sortByValues],
    queryFn: () => getSchools({ filters, filterByMajor: false, sortByValues }),
  });

  return null;
};
